<template>
  <div class="app flex-row" id="login-page">
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="12 text-center mt-5 content-header">
          <h3 style="color: white; font-family: 'Times New Roman'">
            BỘ VĂN HÓA, THỂ THAO VÀ DU LỊCH
          </h3>
          <h2
            style="
              color: white;
              font-weight: 700;
              font-family: 'Times New Roman';
            "
          >
            CỤC DU LỊCH QUỐC GIA VIỆT NAM
          </h2>
          <img src="img/logo_VN.png" style="transform: scale(0.7)" alt />
          <h3
            class="title"
            style="
              color: #fff200;
              margin-bottom: 20px;
              font-family: 'Times New Roman';
              font-weight: bold;
            "
          >
            DU LỊCH TRANG VÀNG - VIỆT NAM
          </h3>
        </b-col>
        <b-col md="12">
          <div style="position: relative">
            <b-card-group>
              <b-card
                no-body
                class="text-white d-md-down-none card-image"
                style="background: transparent; border: none"
              >
                <b-card-body
                  class="text-center"
                  style="padding: 15px; position: relative"
                >
                  <div style="position: absolute; right: 0; bottom: 0">
                    <img src="img/img_login.png" alt width="100%" />
                  </div>
                </b-card-body>
              </b-card>
              <b-card
                no-body
                :class="{
                  'p-2': true,
                  'card-content': !showBlockChoseAccount,
                  'card-content-chose': showBlockChoseAccount
                }"
                style="border-radius: 0"
              >
                <b-card-body style="padding: 45px 0px">

                  <b-alert
                    variant="danger"
                    dismissible
                    :show="mData.dataDefault.showDismissibleAlert"
                    @dismissed="mData.dataDefault.showDismissibleAlert = false"
                    >{{ mData.dataDefault.error }}</b-alert
                  >

                  <el-form
                    :model="mData.dataForm"
                    :rules="mData.validForm"
                    ref="myForm"
                    label-width="100%"
                    label-position="top"
                    @submit.native.prevent
                    style="padding: 0 15px"
                  >
                    <!-- Block nhập Email hoặc Sđt -->
                    <div v-if="showBlockTypeEmailOrPhone">
                      <el-form-item
                        label="Số điện thoại/Email"
                        prop="phoneOrEmail"
                      >
                        <el-input
                          v-model.trim="mData.dataForm.phoneOrEmail"
                          auto-complete="new-password"
                          placeholder="Số điện thoại/Email đã đăng ký"
                          clearable
                        ></el-input>
                      </el-form-item>
                      <el-form-item
                        class="text-center button-group"
                      >
                        <el-button
                          type="primary"
                          @click="searchListAccount()"
                          :disabled="disabledButton"
                          native-type="submit"
                          :loading="loadingButtonSearch"
                        >
                          Tiếp tục
                        </el-button>
                      </el-form-item>
                    </div>
                    <!-- Block nhập mật khẩu -->
                    <div v-if="showBlockTypePassword">
                      <el-form-item
                        :label="aLang.login_account"
                        prop="account"
                      >
                        <el-input
                          v-model.trim="mData.dataForm.account"
                          placeholder="Tên đăng nhập"
                          disabled
                        />
                      </el-form-item>
                      <el-form-item
                        :label="aLang.login_password"
                        prop="password"
                      >
                        <el-input
                          v-model.trim="mData.dataForm.password"
                          auto-complete="new-password"
                          placeholder="Mật khẩu"
                          show-password
                        />
                      </el-form-item>
                      <el-form-item
                        class="text-center button-group"
                      >
                        <el-button
                          type="primary"
                          @click="fn_newLogin()"
                          native-type="submit"
                          :loading="loadingButtonLogin"
                        >
                          {{ aLang.login }}
                        </el-button>
                        <el-button
                          @click="choseAnotherAccount()"
                          native-type="submit"
                          :loading="loadingButtonLogin"
                        >
                          Đổi tài khoản
                        </el-button>
                      </el-form-item>
                    </div>
                    <!-- Block chọn tài khoản -->
                    <div class="list-account" v-if="showBlockChoseAccount">
                      <el-card class="box-card">
                        <div slot="header" class="clearfix">
                          <span class="title-header">Chọn tài khoản</span>
                          <i
                            @click="closeListAccount"
                            style="float: right; padding: 3px 0"
                            class="fas fa-times"
                          ></i>
                        </div>
                        <div
                          class="item"
                          v-for="(item, index) in mData.dataDefault.listAccounts"
                          :key="index"
                          @click="fn_selectAccount(item)"
                        >
                          {{ item.Account }} - {{ item.Ho_ten }}
                        </div>
                      </el-card>
                    </div>
                  </el-form>
                  <b-col
                    v-if="showBlockTypePassword || showBlockTypeEmailOrPhone"
                    md="12"
                    class="text-center"
                    style="padding: 0 5px; position: relative"
                  >
                    <b-link :to="`/auth/forgotPassword?a=${mData.dataForm.phoneOrEmail ? mData.dataForm.phoneOrEmail : ''}`">Quên mật khẩu?</b-link>
                    <br />
                  </b-col>
                </b-card-body>
              </b-card>
            </b-card-group>
          </div>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
import AuthService from "../../service/AuthService";
import LanguageService from "../../service/LanguageService";
import ValidService from "../../service/ValidService";
import MethodService from "../../service/MethodService";
import ExtensionService from "../../service/ExtensionService";
import mushroomDulich from "../../service/api/dulich-api";
import mushroomTrangVang from "../../service/api/trangvang-api";
import config from "../../config.json";
export default {
  data() {
    let checkEmailOrPhone = (rule, value, callback) => {
      if (!MethodService.checkEmailOrPhone(value)) {
        if (value === 'qtndtv') {
          this.checkValidAccount = true
          callback()
        } else {
          this.checkValidAccount = false
          callback(new Error('Vui lòng nhập Số điện thoại/Email'))
        }
      } else {
        this.checkValidAccount = true
        callback()
      }
    }

    return {
      aLang: LanguageService.lang,
      aExtension: ExtensionService,
      showBlockTypeEmailOrPhone: true,
      showBlockChoseAccount: false,
      showBlockTypePassword: false,
      checkValidAccount: false,
      loadingButtonSearch: false,
      loadingButtonLogin: false,
      mData: {
        dataDefault: {
          error: "",
          showDismissibleAlert: false,
          listAccounts: [],
        },
        dataForm: {
          phoneOrEmail: undefined,
          account: undefined,
          password: undefined,
          remember: true,
        },
        validForm: {
          phoneOrEmail: [
            { validator: checkEmailOrPhone, trigger: 'change' },
            { validator: checkEmailOrPhone, trigger: 'blur' }
          ],
          account: [ValidService.required],
          password: [ValidService.required],
        },
      },
    };
  },
  computed: {
    disabledButton() {
      return !this.checkValidAccount
    }
  },
  methods: {
    fn_newLogin() {
      this.$refs["myForm"].validate((valid) => {
        if (valid) {
          this.login(
            this.mData.dataForm.account,
            this.mData.dataForm.password,
            this.mData.dataForm.remember
          )
        } else {
          MethodService.stopLadda();
          return false;
        }
      });
    },
    choseAnotherAccount() {
      if (this.mData.dataDefault.listAccounts.length > 0) {
        this.showBlockTypeEmailOrPhone = false
        this.showBlockChoseAccount = true
        this.showBlockTypePassword = false
        return
      }
      this.showBlockTypeEmailOrPhone = true
      this.showBlockChoseAccount = false
      this.showBlockTypePassword = false
    },
    login(account, password, remember) {
      AuthService.login(account, password, remember )
        .then(() => {
          AuthService.me().then( async (res) => {
            let currentUserId = res.result.id;
            let dataFilterDVCC = {
              filters: "nguoi_tao=" + currentUserId
            }
            if
            (
              res.result.roles.includes('Admin')||
              res.result.roles.includes('Officer') || res.result.roles.includes('VNATAdmin')
            ){
                this.$router.push({ name: "Admin-Home" });
            }else if(res.result.roles.includes('TourAgent') || res.result.roles.includes('TourAgent_Pending')){
              this.$router.push({ name: "Admin-ThongTinCongTyLuHanh-detail" });

            }
            else if(res.result.roles.includes('SafePlace')){
              let donViCungCapChoDuyetRes = await mushroomTrangVang.tv_don_vi_cung_cap_cho_duyet.getAllAsync(dataFilterDVCC);
              let donViCungCapRes = await mushroomTrangVang.tv_don_vi_cung_cap.getAllAsync(dataFilterDVCC);
              if (donViCungCapChoDuyetRes.result[0] || donViCungCapRes.result[0]) {
                this.$router.push({ name: "Admin-ThongTinDDAT-detail" });
              } else if(!donViCungCapChoDuyetRes.result[0] || !donViCungCapRes.result[0]) {
                this.$router.push({ name: "Admin-ChinhSachVaQuyenLoi-infomation" });
              } else{
                this.mData.dataDefault.showDismissibleAlert = true;
                this.mData.dataDefault.error = LanguageService.lang.login_error;
              }
            }else if(res.result.roles.includes('TrangVangContentManager') || res.result.roles.includes('TrangVangCompanyManager')){
              this.$router.push({ name: "Admin-Home" });

            }else{
              this.mData.dataDefault.showDismissibleAlert = true;
              this.mData.dataDefault.error = LanguageService.lang.login_error;
            }
            this.loading = false
          })
        })
        .catch(() => {
          this.loading = false
          this.mData.dataDefault.showDismissibleAlert = true;
          this.mData.dataDefault.error = LanguageService.lang.login_error;
        });
    },
    fn_resetForm() {
      this.$refs["myForm"].resetFields();
    },
    setToken(domain, qparams) {
      return `${domain}?${this.queryBuilder(qparams)}`;
    },
    queryBuilder(parameters) {
      if (typeof parameters === "string") return parameters;

      let query = [];
      for (let key in parameters) {
        if (parameters.hasOwnProperty(key)) {
          query.push(key + "=" + encodeURIComponent(parameters[key]));
        }
      }

      return query.join("&");
    },
    searchListAccount() {
      this.mData.dataDefault.showDismissibleAlert = false
      this.loadingButtonSearch = true
      this.$refs["myForm"].validate(async (valid) => {
        if (!valid) {
          this.loadingButtonSearch = false
          return false
        }
        let body = {
          nguon: 'trang_vang',
          phoneOrEmail: this.mData.dataForm.phoneOrEmail,
        }
        try {
          const res = await mushroomDulich.user.getAccountByPhoneOrEmailAsync({
            body: body
          })
          console.log('res', res)
          if (!res.result || res.result.length == 0) {
            this.mData.dataDefault.showDismissibleAlert = true
            this.mData.dataDefault.error = 'Không tồn tại tài khoản nào đăng ký bằng số điện thoại/email này'
          } else if (res.result && res.result.length == 1) {
            this.mData.dataForm.account = res.result[0].Account
            this.showBlockTypeEmailOrPhone = false
            this.showBlockTypePassword = true
          } else {
            this.mData.dataDefault.listAccounts = res.result
            this.showBlockTypeEmailOrPhone = false
            this.showBlockChoseAccount = true
            this.showBlockTypePassword = false
          }
          this.loadingButtonSearch = false
        } catch (err) {
          this.mData.dataDefault.showDismissibleAlert = true
          this.mData.dataDefault.error = err.detail ? err.detail : 'Có lỗi xảy ra'
          this.loading = false
        }
      });
    },
    fn_selectAccount(account) {
      this.mData.dataForm.account = account.Account
      this.showBlockTypeEmailOrPhone = false
      this.showBlockChoseAccount = false
      this.showBlockTypePassword = true
    },
    closeListAccount() {
      this.showBlockTypeEmailOrPhone = true
      this.showBlockChoseAccount = false
      this.showBlockTypePassword = false
      this.listAccounts = []
    },
  },
};
</script>

<style scoped lang="scss">
.button-group {
  margin-top: 40px;
}

::v-deep .el-form-item__label {
  font-weight: 700;
  &::before {
    content: '*';
    color: #F56C6C;
    margin-right: 4px;
  }
}

::v-deep .el-input__inner {
  border-radius: 12px;
  box-shadow: 0 0 3px rgba(51, 51, 51, 0.5);
  height: 35px;
}

.box-image {
  height: 40px;
  width: 100%;
  position: relative;
}
.image {
  position: absolute;
  max-width: 100%;
  max-height: 100%;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  object-fit: contain;
  object-position: center;
}

.link {
  color: white;
  font-size: 12px;
}
.box-address {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}
.card-content {
  max-width: 36%;
  min-height: 381px;
}
::v-deep .card-content-chose {
  max-width: 36%;
  min-height: 381px;
  .card-body {
    padding: 0 !important;
    .el-form {
      padding: 0 !important;
      .list-account {
        .el-card {
          .el-card__header {
            padding: 10px 20px;
            .title-header {
              font-weight: 700;
              font-size: 18px;
            }
          }
          .el-card__body {
            height: 312px;
            overflow-y: auto;
            // display: flex;
            .item {
              text-align: center;
              font-weight: 600;
              margin: 0 auto;
              // width: 130px;
              // height: 40px;
              padding: 10px 20px;
              color: #fff;
              background-color: #409eff;
              border-color: #409eff;
              border-radius: 12px;
              cursor: pointer;
              text-transform: uppercase;
              margin-bottom: 10px;
              &:hover {
                background-color: #66b1ff;
                border-color: #66b1ff;
              }
            }
          }
        }
      }
    }
  }
}

.app-qr {
  position: absolute;
  /*right: calc((105px + 105px + 40px) * -1);*/
  right: -345px;
  bottom: 0;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
}
.image-box {
  display: block;
  width: 105px;
  height: 105px;
  margin-left: 10px;
  margin-top: 10px;
}

.image-box img {
  object-fit: contain;
  object-position: center;
}

/*.image1 {
  margin-right: 20px;
}*/

.app-qr-mobile {
  display: none;
}

.box-image-hdsd,
.box-image-qr {
  display: none;
}

.button-register {
  display: block;
  text-decoration: none;
  margin: 10px auto 0;
  padding: 13px 25px;
  width: 135px;
  font-size: 14px;
}

@media screen and (max-width: 1820px) {
  .app-qr {
    flex-direction: column;
    /*right: calc((100vw - 1140px + 210px) / -4);*/
    right: -115px;
  }

  /*.image1 {
    margin-bottom: 20px;
    margin-right: 0;
  }*/
}

@media screen and (max-width: 1365px) {
  /* .link-address {
    width: 50%;
    margin: 5px 0;
  } */
  .content-header {
    margin-bottom: 40px;
  }
  .box-address {
    flex-wrap: wrap;
    justify-content: space-around;
  }
  .app-qr {
    display: none;
  }
  .app-qr-mobile {
    display: flex;
    flex-direction: row;
    justify-content: space-around;
    margin: 20px 0;
  }
}
@media screen and (max-width: 1199px) {
  .card-image {
    display: none;
  }
  .card-content {
    max-width: 400px;
    margin: auto !important;
  }

  .text-link {
    display: none;
  }

  .link-address {
    width: auto;
    margin: 0 10px;
  }

  .box-address {
    justify-content: center;
  }
  .image {
    position: unset;
    transform: translate(0, 0);
  }

  .app-qr {
    /*right: calc((100vw - 400px - 218px) / 8);*/
    right: 150px;
    display: flex;
  }

  .app-qr-mobile {
    display: none;
  }
}

@media screen and (max-width: 991px) {
  .card-image {
    display: none;
  }
  .card-content {
    max-width: 400px;
    margin: auto !important;
  }
  .app-qr {
    /*right: calc((100vw - 400px - 218px) / 8);*/
    right: 30px;
    display: flex;
  }

  .app-qr-mobile {
    display: none;
  }
}

@media screen and (max-width: 767px) {
  h3 {
    font-size: 16px;
  }
  h2 {
    font-size: 17px;
  }
  h5 {
    font-size: 14px;
  }
  .app-qr {
    display: none;
  }
  .text-link {
    display: none;
  }
  .link-address {
    width: auto;
    margin: 0;
  }
  .box-address {
    justify-content: space-between;
  }
  .image {
    position: unset;
    transform: translate(0, 0);
  }
  .text {
    font-size: 12px;
  }
  .title {
    margin-bottom: 0px !important;
  }

  .button-register {
    display: block;
    margin: 10px auto 0;
    width: 100px;
  }

  .box-image-hdsd {
    position: absolute;
    width: calc((100% - 160px) / 4);
    top: -57px;
    left: 10px;
    display: block;
  }
  .box-image-hdsd-web {
    left: 73px;
  }
  .box-image-hdsd div {
    padding-bottom: 100%;
    width: 100%;
  }
  .box-image-hdsd img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    top: 0;
    left: 0;
  }

  .box-image-qr {
    position: absolute;
    width: calc((100% - 30px) / 3);
    top: -95px;
    right: 5px;
    display: block;
  }
  .box-image-qr div {
    padding-bottom: 100%;
    width: 100%;
  }
  .box-image-qr img {
    position: absolute;
    width: 100%;
    height: 100%;
    object-fit: contain;
    object-position: center;
    top: 0;
    left: 0;
  }
}
</style>
